module.exports = __webpack_public_path__ + "img/mailbox.e6295521.svg";